import './layout.scss';

import React from 'react';

export const Page = (
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) => {
  return <div {...props} className={`page ${props.className ? props.className : null}`} />;
};
